import axios from "axios";
import { useMemo } from "react";
import { useAuth } from "@clerk/react";
import { tr, getLang } from "./i18n";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const publicApi = axios.create({ baseURL: API });

export function useApi() {
  const { getToken } = useAuth();
  return useMemo(() => {
    const inst = axios.create({ baseURL: API });
    inst.interceptors.request.use(async (c) => {
      const t = await getToken();
      if (t) c.headers.Authorization = `Bearer ${t}`;
      return c;
    });
    return inst;
  }, [getToken]);
}

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => `${tr(String(x.loc?.slice(-1)[0] || "").replace(/_/g, " "))}: ${tr(String(x.msg).replace("Value error, ", ""))}`).join("; ");
  return tr(typeof d === "string" ? d : "Something went wrong. Please try again.");
}

export const inr = (n) => {
  const v = Number(n || 0);
  const s = Math.abs(v).toLocaleString("en-IN", { minimumFractionDigits: Number.isInteger(v) ? 0 : 2, maximumFractionDigits: 2 });
  return `${v < 0 ? "-" : ""}₹${s}`;
};
export const fmtDate = (s) => (s ? new Date(s).toLocaleString(getLang() === "hi" ? "hi-IN" : "en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");

export function getUtm() {
  const p = new URLSearchParams(window.location.search);
  const saved = JSON.parse(sessionStorage.getItem("utm") || "{}");
  const fresh = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((k) => { if (p.get(k)) fresh[k] = p.get(k); });
  const utm = { ...saved, ...fresh, referrer: saved.referrer || document.referrer || "" };
  sessionStorage.setItem("utm", JSON.stringify(utm));
  return utm;
}
